module.exports = __webpack_public_path__ + "img/icon_2_10.43cd8a4a.png";